import { useEffect, useState } from 'react';

export function useMedia(query: string, defaultValue = false): boolean {
  const [match, setMatch] = useState(() => {
    if (typeof window === 'undefined') return defaultValue;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatch(e.matches);
    mql.addEventListener('change', onChange);
    setMatch(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return match;
}

export const useIsDesktop = () => useMedia('(min-width: 768px)', true);
export const useHasHover = () => useMedia('(hover: hover)', true);
